<template>
  <ALink
    :to="{ url: media.image.filename, linktype: 'url', target: '_blank' }"
    class="inline-block w-full group"
    :style="{ '--color': primaryColor?.hex || 'black' }"
  >
    <div class="overflow-hidden">
      <div
        class="w-full relative pb-75% clamp-rounded-1-1 bg-skeleton skeleton-loading-image effect-hover-tilt-media"
      >
        <AImage
          :src="media.image.filename"
          :alt="media.image.alt"
          :focalPoint="media.image.focus"
          :ratio="{ w: 4, h: 3 }"
          :sizes="[
            { bpMin: 'tp', vw: 25 },
            { bpMin: 'mpl', vw: 50 },
            { bpMin: '0', vw: 100 },
          ]"
          class="absolute top-0 w-full"
          @load="imgLoaded = true"
        />
      </div>
    </div>
    <span
      class="flex justify-between items-center clamp-gap-1-1 clamp-mt-1-2 color-[--color]"
    >
      <span
        class="text-body-sm whitespace-nowrap overflow-hidden text-ellipsis"
        >{{ filename }}</span
      >
      <AIcon icon="custom-arrow-down-line" class="shrink-0" />
    </span>
  </ALink>
</template>
<script setup lang="ts">
import { MediaImageStoryblok } from '@/types';
import useConfig from '@/composables/useConfig';

const { primaryColor } = useConfig();
export interface MediaCardTemplateProps {
  media: MediaImageStoryblok;
}
const props = defineProps<MediaCardTemplateProps>();

const imgLoaded = ref(false);
const filename = computed(() => props.media.image.filename.split('/').pop());
</script>

<style scoped lang="scss"></style>
